let activityTrackerInstance = null;
let locationTrackerInstance = null;
let presenceTrackerInstance = null;

export function setTrackers({
  activityTracker = null,
  locationTracker = null,
  presenceTracker = null,
} = {}) {
  activityTrackerInstance = activityTracker;
  locationTrackerInstance = locationTracker;
  presenceTrackerInstance = presenceTracker;
}

export function clearTrackers() {
  activityTrackerInstance = null;
  locationTrackerInstance = null;
  presenceTrackerInstance = null;
}

export async function stopAllTrackers(reason = "manual-stop") {
  const tasks = [];

  if (
    presenceTrackerInstance &&
    typeof presenceTrackerInstance.stop === "function"
  ) {
    tasks.push(presenceTrackerInstance.stop(reason));
  }

  if (
    locationTrackerInstance &&
    typeof locationTrackerInstance.stop === "function"
  ) {
    tasks.push(Promise.resolve(locationTrackerInstance.stop(reason)));
  }

  if (
    activityTrackerInstance &&
    typeof activityTrackerInstance.stop === "function"
  ) {
    tasks.push(Promise.resolve(activityTrackerInstance.stop(reason)));
  }

  await Promise.allSettled(tasks);
}
